export default "__VITE_ASSET__e72da251__"